import * as React from 'react';

import { CMLParser, CMLUtils } from 'bundles/cml';
import { questions } from 'bundles/discussions/constants';

import _t from 'i18n!nls/discussions';

const MAX_CONTENT_LEN = questions.details.maxChars;
const CONTENT_WARN_LEN = questions.details.warnChars;
const MIN_CML_LEN = CMLParser.EMPTY_CML.length + '<text></text>'.length;

const getApproachingLimitString = () => _t('You are approaching the character limit |\u00a0');
const getExceededLimitString = () => _t('You have exceeded the character limit |\u00a0');

const DiscourseCMLUtils = {
  generateContentLengthWarning(cml: $TSFixMe) {
    const contentLength = CMLUtils.getValue(cml).length;
    let contentLengthWarning;
    // This is not the most accurate way to calculate length,
    // but the length is so long that we don't really care.
    if (contentLength > CONTENT_WARN_LEN + MIN_CML_LEN && contentLength <= MAX_CONTENT_LEN + MIN_CML_LEN) {
      contentLengthWarning = (
        <div className="c-form-error-message">
          {getApproachingLimitString() + contentLength + '/' + MAX_CONTENT_LEN}
        </div>
      );
    } else if (contentLength > MAX_CONTENT_LEN + MIN_CML_LEN) {
      contentLengthWarning = (
        <div className="c-error-text c-form-error-message">
          {getExceededLimitString() + contentLength + '/' + MAX_CONTENT_LEN}
        </div>
      );
    }
    return contentLengthWarning;
  },

  /*
    Validate CML and return error code to distinguish between different errors
  */
  checkForErrors: (cml: $TSFixMe) => {
    if (CMLUtils.isEmpty(cml)) {
      return 'TOO_SHORT';
      // This is not the most accurate way to calculate length,
      // but the length is so long that we don't really care.
    } else if (CMLUtils.getValue(cml).length > MAX_CONTENT_LEN + MIN_CML_LEN) {
      return 'TOO_LONG';
    }
    return undefined;
  },

  validateLength(cml: $TSFixMe) {
    if (CMLUtils.isEmpty(cml)) {
      return false;
      // This is not the most accurate way to calculate length,
      // but the length is so long that we don't really care.
    } else if (CMLUtils.getValue(cml).length > MAX_CONTENT_LEN + MIN_CML_LEN) {
      return false;
    } else {
      return true;
    }
  },

  getImageUploadOptions(courseId: $TSFixMe, questionId?: $TSFixMe) {
    return {
      context: {
        courseId,
        ...(questionId ? { questionId } : {}),
      },
      pendingAssetCreation: {
        assetType: 'image',
        typeName: 'pending',
        tags: [],
      },
      assetCreationUrl: '/api/onDemandDiscussionsAssetCreationAttempts.v1',
    };
  },
};

export default DiscourseCMLUtils;

export const { generateContentLengthWarning, checkForErrors, validateLength, getImageUploadOptions } =
  DiscourseCMLUtils;

export const getErrorMessageFromCode = (code?: string) => {
  let message;
  switch (code) {
    case 'FORUM_POST_INVALID_TERM_EXCEPTION':
      message = _t(
        'There is something wrong with your post. Please review and edit it or contact support for assistance.'
      );
      break;
    default:
      message = _t('Something went wrong. Please reload the page and try again.');
  }
  return message;
};
